import { render, staticRenderFns } from "./ClubPage.vue?vue&type=template&id=63fbb964&scoped=true"
import script from "./ClubPage.vue?vue&type=script&lang=js"
export * from "./ClubPage.vue?vue&type=script&lang=js"
import style0 from "./ClubPage.vue?vue&type=style&index=0&id=63fbb964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbb964",
  null
  
)

export default component.exports